













































































import { AreaInfo, GoodsListItem } from "@/types";
import { hiddenLoading, showLoading } from "@/utils/loading";
import { initUserInfoByUrl } from "@/utils/userInfoByUrl";
import dayjs from "dayjs";
import { apiGet, getCache, getCDNArea, getCDNGoodsDetails } from "jhm_api_ts";
import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import IcbcApp from "jhm_icbc";
import { btnClick, resourceClick } from "@/utils/analysysAgent";

@Component
export default class Home extends Vue {
  @State("pid") public pid!: string;
  @State("aid") public aid!: string;
  goodsList: Array<GoodsListItem> = [];
  area: AreaInfo = {} as AreaInfo;
  isSell = false; //是否开售
  order_id = this.$route.query.order_id as string;
  currentTime = dayjs().unix();

  get card() {
    let h5_extend;
    if (this.area.h5_extend) {
      h5_extend = JSON.parse(this.area.h5_extend) || {};
      const { cardLink, cardLinkImg } = h5_extend;
      return { cardLink, cardLinkImg };
    }
    return {};
  }

  get isApp() {
    return IcbcApp.isICBCApp();
  }

  async mounted() {
    showLoading();

    initUserInfoByUrl(this.$route.query);

    this.checkSaleStatus();
    this.refreshTime();

    const { info: area } = await getCache(getCDNArea, this.aid);
    this.area = area;
    this.goodsList = await this.initGoodsList();

    hiddenLoading();

    // 活动提示文案-存在即显示(默认放到最后执行)(存在订单号为支付返回无需弹框)
    if (!this.order_id && this.area.activity_tpis) {
      this.$dialog.alert({
        title: "温馨提示",
        message: this.area.activity_tpis,
      });
    }
    if (dayjs().isAfter(dayjs("2023-07-01 00:00:00"))) {
      this.$dialog.alert({
        title: "温馨提示",
        message: "活动已结束，感谢关注!",
      });
    }
  }

  refreshTime() {
    const timeout = setTimeout(() => {
      this.currentTime = dayjs().unix();
      this.refreshTime();
    }, 1000);
    this.$once("hook:destroyed", () => {
      clearTimeout(timeout);
    });
  }

  /**
   * @Description: 检查售卖状态
   */
  async checkSaleStatus() {
    if (await this.checkCountdownTime()) {
      this.isSell = true;
      return;
    }

    let sellTimeout: any = null;
    const countdown = () => {
      sellTimeout = setTimeout(async () => {
        if (
          dayjs().unix() >=
          dayjs(`${dayjs().format("YYYY-MM-DD")} 10:30:00`).unix()
        ) {
          if (await this.checkCountdownTime()) {
            this.isSell = true;
            clearTimeout(sellTimeout);
          } else {
            countdown();
          }
        } else {
          this.isSell = false;
          countdown();
        }
      }, 200);
    };
    countdown();

    this.$once("hook:destroyed", () => {
      clearTimeout(sellTimeout);
    });
  }
  async checkCountdownTime() {
    let {
      data: { ttl, message },
    }: any = await apiGet("/apiv4/order/getStartTtl", {
      aid: this.aid,
    }).catch((e) => {
      this.$toast.fail(e.message || e.info);
      throw e.message || e.info;
    });
    if (ttl > 0) {
      return false;
    }
    return true;
  }
  /**
   * @Description: 初始化商品列表
   */
  async initGoodsList(): Promise<Array<GoodsListItem>> {
    let { data: list }: any = await apiGet("/apiv4/goods/getStocks", {
      aid: this.aid,
      city: sessionStorage.getItem("city") || "",
    });

    list = list
      .map(async (item: any) => {
        try {
          let { info } = await getCDNGoodsDetails(item.gid);
          info.now_num = item.num;
          try {
            if (typeof info.h5_extend === "string") {
              info.h5_extend = JSON.parse(info.h5_extend);
            }
          } catch (e) {
            info.h5_extend = {};
          }
          return info;
        } catch (e) {
          return null;
        }
      })
      .filter((item: GoodsListItem) => item);

    return Promise.all(list);
  }

  toRule(): void {
    btnClick("活动规则");
    this.$router.push("/rule");
  }

  toCoupon(): void {
    btnClick("我的订单");
    this.$router.push("/coupon");
  }

  toDetails(item: any): void {
    console.log(item, 123);
    resourceClick({
      resource_name: item.name,
      resource_rank: `${item.sort}`,
      btn_name: "立即抢购",
      product_id: item.id,
      product_type: item.code_type,
      product_price_original: Number(item.pre_price),
      product_price_discount: Number(item.price),
      desc: `${item.now_num}`,
    });
    this.$router.push({
      path: "/details",
      query: {
        gid: item.id,
      },
    });
  }
  toActivity(url: string) {
    if (url) {
      if (/^HD/g.test(url)) {
        IcbcApp.getActivityInfo(url);
      } else if (/^(http|https|\/\/)/g.test(url)) {
        // 链接
        window.location.href = url;
      } else if (/#/g.test(url)) {
        // 不同项目跳转
        window.location.href = url;
      } else {
        // 页面内跳转
        this.$router.push(url);
      }
    }
  }
  toCard(url: string) {
    resourceClick({
      resource_name: "办卡入口",
      btn_name: "立即点此来办卡",
    });
    this.toActivity(url);
  }
  toConversion(url: string) {
    resourceClick({
      resource_name: "积分入口",
    });
    this.toActivity(url);
  }

  toQuestionnaire() {
    btnClick("小问卷");
    IcbcApp.getActivityInfo("HD046012sYEmtfS12X");
  }

  getNum(num: string) {
    if (this.isSell) {
      return num;
    }
    if (
      this.currentTime >=
      dayjs(`${dayjs().format("YYYY-MM-DD")} 10:29:00`).unix()
    ) {
      return num;
    }
    return 0;
  }
}
